import { render, staticRenderFns } from "./ListaUcsis.vue?vue&type=template&id=2287ae5a"
import script from "./ListaUcsis.vue?vue&type=script&lang=js"
export * from "./ListaUcsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports